const KEY = 'selectedBrandId';

export function read(): number | null {
  if (typeof window === 'undefined') return null;
  const raw = window.sessionStorage.getItem(KEY) ?? window.localStorage.getItem(KEY);
  const parsed = raw == null ? NaN : parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

export function write(brandId: number): void {
  if (typeof window === 'undefined') return;
  const value = String(brandId);
  window.sessionStorage.setItem(KEY, value);
  window.localStorage.setItem(KEY, value);
}

/** localStorage only — used to "claim ownership" right before a link click opens a new tab. */
export function writeLocal(brandId: number): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KEY, String(brandId));
}

/**
 * Temporarily seed sessionStorage with `brandId`, run `fn`, then restore the previous
 * value. Used to make a script-opened new tab (which inherits sessionStorage) boot on
 * the target brand without leaving the parent tab's session pointing there.
 */
export function withSessionSeed<T>(brandId: number, fn: () => T): T {
  if (typeof window === 'undefined') return fn();
  const value = String(brandId);
  const prev = window.sessionStorage.getItem(KEY);
  window.sessionStorage.setItem(KEY, value);
  window.localStorage.setItem(KEY, value);
  try {
    return fn();
  } finally {
    if (prev !== null) window.sessionStorage.setItem(KEY, prev);
    else window.sessionStorage.removeItem(KEY);
  }
}
